import React, { Component } from 'react';
import { findDOMNode } from 'react-dom';
import lodash from 'lodash';

import styles from './Dropdown.scss';

export default class Dropdown extends Component {
    constructor() {
        super();
        this.state = {
            extended: null
        };
        this.onOutsideClick = this.onOutsideClick.bind(this);
    }

    componentDidMount(){
        if(document.addEventListener){
            document.addEventListener('click', this.onOutsideClick, true);
        }
    }

    componentWillUnmount(){
        if(document.removeEventListener){
            document.removeEventListener('click', this.onOutsideClick, true);
        }
    }

    shouldComponentUpdate(nextProps, nextState) {
        if(!lodash.isEqual(this.props.activeText, nextProps.activeText) ||
            !lodash.isEqual(this.state.extended, nextState.extended)) {
            return true;
        }
        return false;
    }

    onOutsideClick(e){
        const { extended } = this.state;
        const bodyNode = findDOMNode(this.refs.dropdown);

        if(lodash.isNil(bodyNode)){
            return;
        }

        const isDescendant = bodyNode.contains(e.target);

        if (!isDescendant && extended) {
            this.close();
        }
    }

    close() {
        this.setState({extended: false});
    }

    open() {
        this.setState({extended: true});
    }

    optionHandler(handler) {
        this.close();
        handler();
    }

    getListStyling(extended) {
        if (lodash.isNil(extended)) {
            return styles.initial;
        }
        return extended ? styles.visible : styles.hidden;
    }

    render() {
        const { extended } = this.state;
        const { activeText, options, label } = this.props;

        const listStateStyling = this.getListStyling(extended);

        return (
            <section className={styles.container}  data-cy="Dropdown">
                {label && <label data-cy="Dropdown-label">{label}</label>}
                <div className={styles.header} ref="dropdown">
                    <div className={styles.header__box} onClick={() => this.open()} data-cy="Dropdown-onClick">
                        <span className={styles.header__box__text} data-cy="Dropdown-activeText">
                            {activeText}
                        </span>
                        <i className={styles.header__box__icon}>expand_more</i>
                    </div>
                    <OptionList
                        className={`${styles.OptionList} ${listStateStyling}`}
                        optionsStyle={styles.OptionList__item}
                        options={options}
                        onOptionClick={this.optionHandler.bind(this)} />
                </div>
            </section>
        );
    }
}

const OptionList = ({ options, optionsStyle, onOptionClick, className }) => {
    return (
        <ul className={className} data-cy="Dropdown-ul">
            {options.map((o,i) => <li className={optionsStyle} data-cy={'Dropdown-' + i} key={i} onClick={() => onOptionClick(o.handler)}>{o.label}</li>)}
        </ul>
    );
};
